export default "__VITE_ASSET__7dae67f5__"